import { FC, memo } from 'react'
import { ListContainer } from '@App/libs/components/list/ListComponent'
import {
    AlertaListItem,
    checkUserPROPermissions,
    formatFriendlyDate,
    getIconByString
} from '@App/libs/utils/geral'
import { CardDS } from '@App/libs/components/geral/JOTADS.components'
import { useRouter } from 'next/router'
import { StoreType } from '@App/api/types/store'
import { useSelector } from 'react-redux'
import { makeBreadItemsFromOS } from '@App/libs/components/ds/Breadcrumb'
import { getColorVertical } from '@App/libs/utils/pro'
import { SAUDE_SLUG, VerticalName } from '@App/libs/interfaces/PRO.interfaces'
import { Editoria } from '@App/libs/style/editoria.style'

type ListContentFromAlertasProps = {
    items: AlertaListItem[]
    alertType: string
}

const getVerticalNameByAlertType = (alertType: string): VerticalName => {
    if (alertType === VerticalName.PODER.toLowerCase()) {
        return VerticalName.PODER
    }
    if (alertType === SAUDE_SLUG) {
        return VerticalName.SAUDE
    }
    return VerticalName.TECNOLOGIA
}

const getProPermissionKey = (
    alertType: string
):
    | 'has_poder'
    | 'has_tributos'
    | 'has_saude'
    | 'has_trabalhista'
    | 'has_tecnologia'
    | null
    | undefined => {
    if (alertType === VerticalName.PODER.toLowerCase()) {
        return 'has_poder'
    }
    if (alertType === SAUDE_SLUG) {
        return 'has_saude'
    }
    if (alertType === VerticalName.TECNOLOGIA.toLowerCase()) {
        return 'has_tecnologia'
    }
    return null
}

const ListContentFromAlertas: FC<ListContentFromAlertasProps> = ({
    items,
    alertType
}) => {
    const router = useRouter()
    const { auth } = useSelector((state: StoreType) => state)
    const userBO: any = auth.user?.getUserBO()
    const vertical = userBO?.profile?.vertical

    return (
        <div>
            <Editoria.Header data-testid='list-content-from-alertas'>
                {router.asPath && (
                    <Editoria.Breadcrumb
                        items={makeBreadItemsFromOS(router.asPath)}
                    />
                )}
                <Editoria.Title>Alertas</Editoria.Title>
            </Editoria.Header>

            <ListContainer>
                {items.length > 0 &&
                    items?.map((content, index) => (
                        <CardDS
                            key={'alert' + index}
                            title={content.title}
                            titleSearchTerm={''}
                            newsLink={`/${alertType}/alertas/${content.slug}`}
                            size='small'
                            tagLabel={'Alertas'}
                            tagColor={getColorVertical(
                                getVerticalNameByAlertType(alertType)
                            )}
                            tagType='outline'
                            TagLeftIcon={getIconByString('alertas')}
                            subjectTagLabel={getVerticalNameByAlertType(
                                alertType
                            )}
                            subjectTagColor={getColorVertical(
                                getVerticalNameByAlertType(alertType)
                            )}
                            subjectTagDisableHover
                            isSponsored={false}
                            relatedTagLabel={
                                formatFriendlyDate(content.publishedAt).time
                            }
                            relatedTagDisableHover
                            hasSeparator={false}
                            isContentPro={
                                !checkUserPROPermissions(
                                    vertical,
                                    userBO?.profile,
                                    auth,
                                    getProPermissionKey(alertType)
                                )
                            }
                            isUserPro={checkUserPROPermissions(
                                vertical,
                                userBO?.profile,
                                auth,
                                getProPermissionKey(alertType)
                            )}
                            dateTagLabel={
                                formatFriendlyDate(content.publishedAt).date
                            }
                        />
                    ))}
            </ListContainer>
        </div>
    )
}

export default memo(ListContentFromAlertas)
